export default __webpack_public_path__ + "static/media/ar-conte.72b2e6a9.jpg";